export default `
  <svg 
    height="100%" 
    viewBox="0 0 40 40" 
    width="100%" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m2744.99995 1155h9.99997 10.00008v9.98139h-10.00008-9.99997-9.99998v9.9814.64001 9.28323.05815 9.9234h-9.99997v-9.9234-.05815-9.28323-.64001-9.9814-9.98139h9.99997zm9.99961 29.88552h-9.94167v-9.92324h19.93595v10.27235c0 2.55359-1.01622 5.00299-2.82437 6.80909-1.80867 1.8061-4.26182 2.82181-6.82018 2.82335h-.34973z" 
      fill="#617bff" 
      fill-rule="evenodd" 
      transform="translate(-2725 -1155)"/>
  </svg>
`;
